import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { transactionsReqSchema } from "~/entities/transaction";

import { Transactions } from "./Transactions";

export function createTransactionsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/transactions",
    component: Transactions,
    validateSearch: transactionsReqSchema,
    head: () => ({
      meta: [{ title: "Search Transactions" }],
    }),
  });
}
